import { pushAnalyticsObjToDataLayer } from "@/utils/helper"
import {
  DESIGNSERVICES,
  PAGELOAD,
} from "@/components/Default/Text/v1/analytics/constant"

export const datalayerForLinkEvent = e => {
  const { target: { href = "", textContent = "" } = {} } = e

  const eventInfo = {
    clickInternalLinks: "false",
    eventAction: `${PAGELOAD}:${DESIGNSERVICES}:${textContent}`,
    eventMsg: "n/a",
    eventName: `${PAGELOAD}:${DESIGNSERVICES}:${textContent}`,
    eventStatus: "n/a",
    eventType: "help support",
    internalLinkName: textContent,
    internalLinkPosition: DESIGNSERVICES,
    internalLinkType: `${PAGELOAD}:email us`,
    internalLinkURL: href,
    internalLinkZoneName: `${PAGELOAD}:${DESIGNSERVICES}`,
  }
  if (textContent === "services@kohler.com") {
    pushAnalyticsObjToDataLayer(eventInfo)
  }
}
